<template>
  <a class="product" :href="'/detail/'+item.id" @click.prevent="onClick">
    <img src="@/assets/img/voucher.png" alt="LAN1 Voucher-Image" />
    <h2 is="sui-header" size="small">{{ title }}</h2>
    <i18n-n :value="price" format="currency" locale="de-DE"></i18n-n>
  </a>
</template>

<script>
  export default {
    name: 'Product',
    props: {
      item: {
        type: Object,
        required: true
      }
    },
    methods: {
      onClick() {
        this.$store.commit('SELECT_VOUCHER', this.item.id)
        this.$router.push('detail/' + this.item.id)
      }
    },
    computed: {
      title: function () {
        return this.$t(this.item.name)
      },
      price: function () {
        return (this.item.price / 100)
      },
    }
  }
</script>
